import type { IconSvgObject } from './types';

const ClosedCaptionIcon: IconSvgObject = [
  ["path", { d: "M22 19V5C22 3.89543 21.1046 3 20 3H4C2.89543 3 2 3.89543 2 5V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.5 9H8C7.44772 9 7 9.44772 7 10V14C7 14.5523 7.44772 15 8 15H10.5M17 9H14.5C13.9477 9 13.5 9.44772 13.5 10V14C13.5 14.5523 13.9477 15 14.5 15H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ClosedCaptionIcon;
